import React from 'react'
import slideImg from '../assets/slider-images/services.gif'

function ServicesSlides() {
    return (
        <div className="py-4">
            <img className="img-fluid" src={slideImg} alt="" />
        </div>
    )
}

export default ServicesSlides